export enum QuoteRelatedDraftInvoiceType {
  DepositInvoice = 'depositInvoice',
  Invoice = 'invoice',
}
